/* eslint-disable react/prop-types */

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, FormGroup, Input, Label, Modal, Row } from "reactstrap";
import axiosInstance from "src/common/axiosInstance";
import { useDispatch } from "react-redux";
import { updateProposal } from "src/slices/Proposals/reducer";
interface SubmitSuggestionModalProps {
    isOpen: boolean;
    toggle: () => void;
    proposal_id: number;
    setHideSignNow: (val: boolean) => void;
    setHideSubmitSuggestion : (val: boolean) => void;
}

const SubmitSuggestion: React.FC<SubmitSuggestionModalProps> = ({
    isOpen,
    toggle,
    proposal_id,
    setHideSignNow,
    setHideSubmitSuggestion
}) => {
    const [suggestion, setSuggestion] = useState('');
    const [modalThankYou, setModalThankYou] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    function togThankyou() {
        setModalThankYou(!modalThankYou);
        removeBodyCss();
        if(modalThankYou)
            setLoading(false);
    }
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    const SubmitSuggestion = async () => {
        setLoading(true);
        const response = await axiosInstance.post("/submit-suggestion", { suggestion: suggestion, proposal_id: proposal_id });
        if (response.data.status) {
            const proposalUpdate = {
                id: response.data.data.id,
                status: response.data.data.proposal_status
            }
            dispatch(updateProposal(proposalUpdate));
            toggle();
            setHideSignNow(true);
            setHideSubmitSuggestion(true);
            togThankyou();
        } else {
            toast.error("Something went Wrong!");
            setLoading(false);
        }
    }
    const getLastSuggestion = async () => {
        if (isOpen) {
            try {
                const response = await axiosInstance.get("/last-suggestion", {
                    params: { proposal_id: proposal_id },
                });
                if (response.data.suggestion) {
                    setSuggestion(response.data.suggestion);
                }
            } catch (err) {
                console.error("Error fetching last suggestion:", err);
            }
        }
    };

    useEffect(() => {
        getLastSuggestion();
    }, [isOpen]);


    return (
        <>
            <Modal size="lg" isOpen={isOpen} toggle={toggle}>
                {/* isOpen={isOpen} toggle={toggle} */}
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myLargeModalLabel">
                        Add Suggestion
                    </h5>
                    <button
                        onClick={toggle} // Use toggle instead of directly manipulating setmodal_large
                        type="button"
                        className="close"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col xl={12}>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Input
                                            type="textarea"
                                            name="text"
                                            id="exampleText"
                                            value={suggestion}
                                            onChange={(e) => setSuggestion(e.target.value)}
                                            placeholder="Type your message here..."
                                            rows={5}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* Save Button */}
                    <Row className="mb-3">
                        <Col md={12} style={{ textAlign: "right" }}>
                            <Button
                                color="primary"
                                type="button" // Ensure button type is "button" to avoid form submission on click
                                className="w-md"
                                onClick={SubmitSuggestion} // Call the handler when saving
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    "Add Suggestion"
                                )}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>


            <Modal size="md" isOpen={modalThankYou} toggle={togThankyou}>
                <div className="modal-body text-center">
                    <h5 className="modal-title mt-0" id="myLargeModalLabel">
                        Thank You
                    </h5>
                    <br></br>
                    <p>Your requested changes have been submitted to your Account Executive, they will review and contact you with any questions.</p>
                    <p>An updated plan will be sent back to you soon.</p>
                    {/* Save Button */}
                    <Row className="mb-3">
                        <Col md={12} style={{ textAlign: "right" }}>
                            <Button
                                color="primary"
                                type="button" // Ensure button type is "button" to avoid form submission on click
                                className="w-md"
                                onClick={togThankyou} // Call the handler when saving
                            >
                                OK
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </>
    )
}

export default SubmitSuggestion;